import React, { useState,useEffect } from "react";
import Navbar from "./Navbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
function TechnicalSupportRequests() {
    const ID = Cookies.get("log_id");
    const [supports,setSupports] = useState([]);
    function Fecth_Support_Requests() {
        axios.get(`${url.path}/fetch_support_requests/`)
        .then((res) =>{
            if (res.data.status){
                var req = res.data.supports;
                setSupports([])
                req.map((r)=>{
                    setSupports((prevState)=>[
                        ...prevState, r
                    ])
                })
            }
        }).catch((err)=>{
            console.log('ERROR',err)
          })
    }
     useEffect(()=>{
        Fecth_Support_Requests();
    },[])
    const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const filteredData = supports.filter((item) =>
      item.Employee_Name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#companytable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>Support Requests</h3>
            </center>
            <div className="search-container">
                <input
                type="text"
                placeholder="Search..."
                onKeyUp={searchTable}
                className="search-input"
                id="search"
                />
            </div>
        <div className="table-container">
            
      <table className="responsive-table" id="companytable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Contact</th>
            <th>Problem</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {supports.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Employee_Name}</td>
              <td>{i.Employee_mail}</td>
              <td>{i.Employee_contact}</td>
              <td>{i.Problem}</td>
              <td>{i.Description}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default TechnicalSupportRequests;